import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/home/Home";
import LoginFromUniID from "./pages/home/LoginFromUniID";
import LoginPage from "./pages/login/Login";
import ResultPage from "./pages/result/Result";
import AccountPage from "./pages/account/Account";
import PlayPage from "./pages/play/Play";
import HistoryPage from "./pages/history/History";
import FlashPage from "./pages/flash/Flash";

import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Routes, Route, Redirect } from "react-router-dom";
import Layout from "./shared/Layout";

import Modal from "react-modal";
Modal.setAppElement("#root");

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/home/fromUniID" element={<LoginFromUniID />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/play" element={<PlayPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/flash" element={<FlashPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
